varying float vAlpha;
varying float vLife;

void main() {
    vec2 uv   = gl_PointCoord - vec2(0.5);
    float dist = length(uv) * 2.0;

    // М'яке коло — Gaussian falloff
    float mask = exp(-dist * dist * 3.5);

    // Колір: темно-сірий внизу → майже прозорий вгорі
    // Легкий теплий відтінок ближче до вогню
    float warmth = 1.0 - vLife;
    vec3 color = mix(
        vec3(0.18, 0.16, 0.14),  // темний теплий дим (молодий)
        vec3(0.30, 0.28, 0.27),  // світліший сірий (старий, вгорі)
        vLife
    );

    float alpha = mask * vAlpha;

    gl_FragColor = vec4(color, alpha);

    #include <colorspace_fragment>
}
